import { ButtonVariant, IButtonProps, IOptionProps } from '@amobee/component-library';
import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { PlannerEndpoints } from 'src/app/planner/constants/planner-endpoints.const';
import { AdvertiserInfoVO } from 'src/app/planner/interfaces/AdvertiserInfo';
import { ConceptType } from '../../planner-edit/constants/ConceptType.const';
import * as _ from 'lodash';
import { BIESettings } from 'src/app/common/components/browse-include-exclude/browse-include-exclude.component';
import { Operator } from 'src/app/planner/enums/Operator.enum';
import { ContextualTargetingType } from '../../planner-edit/constants/ContextualTargetingType.const';

@Component({
  selector: 'contextual',
  templateUrl: './contextual.component.html',
  styleUrls: ['./contextual.component.scss']
})
export class ContextualComponent implements OnInit {

  @Input() group: string;
  @Input() formArray: FormArray;
  @Input() advertiserInfo: AdvertiserInfoVO;
  @Input() isNew: Boolean;

  open: boolean;
  saveButton: IButtonProps = {
    variant: ButtonVariant.PRIMARY,
    label: 'Save',
    onClick: () => {
      this.saveContextualData();
    }
  };
  cancelButton: IButtonProps = {
    variant: ButtonVariant.NEUTRAL,
    label: 'Cancel',
    onClick: () => {
      this.cancel();
    }
  };

  conceptSetSettings = {
    singleSelection: true,
    textField: "name",
    closeDropDownOnSelection: true,
    enableCheckAll: false,
    allowSearchFilter: true,
    endPoint: PlannerEndpoints.conceptSets,
    params: {}
  }

  contextualType: any;
  conceptType = ConceptType;
  contextualTargetingType = ContextualTargetingType;
  selectedConceptSet = [];
  contextualDataConfig: any = {
    include: [],
    exclude: [],
    includeOperator: '',
    excludeOperator: ''
  };
  contextualSettings: BIESettings = {
    url: PlannerEndpoints.concepts
  };
  includeListCount: any = 0;
  excludeListCount: any = 0;
  tooltipTextForInclude: Array<string> = [];
  tooltipTextForExclude: Array<string> = [];
  conceptSetLabel: string = '';

  constructor() { }

  ngOnInit() {
    if (this.isNew) {
      this.contextualType = this.contextualTargetingType.targets.key;
    } else {
      if (!_.isEmpty(this.conceptSetControl.value)) {
        this.contextualType = this.contextualTargetingType.targetsSets.key;
        this.mapConceptSetData();
      } else {
        this.contextualType = this.contextualTargetingType.targets.key;
      }
    }

    this.contextualSettings.param = {
      marketId: this.advertiserInfo.marketId,
      advertiserId: this.advertiserInfo.id,
      conceptType: this.conceptType.contextual.value,
      limit: 20,
      offset: 0,
      searchString: '',
      columnKey: ''
    }
    this.conceptSetSettings.params = {
      marketId: this.advertiserInfo.marketId,
      advertiserId: this.advertiserInfo.id,
      conceptType: [this.conceptType.contextual.value, this.conceptType.bi.value],
      limit: 20,
      offset: 0,
      searchString: ''
    };
    this.updateSelectionText();
  }

  mapConceptSetData(): void {
    this.selectedConceptSet = !_.isEmpty(this.conceptSetControl.value) ? [this.conceptSetControl.value] : [];
  }

  handleOnSelectChange(event: IOptionProps) {
    this.contextualType = event.value;
  }

  onConceptSetSelect(selectedItem) {
    this.selectedConceptSet = [{
      id: selectedItem.id,
      name: selectedItem.name
    }];
  }

  openSidebar() {
    if (!this.isContextualDisabled) {
      this.open = true;
      this.updateDataConfig();
    }
  }

  updateDataConfig() {
    this.contextualDataConfig = {
      include: _.clone(this.includeStackControl.value),
      exclude: _.clone(this.excludeStackControl.value),
      includeOperator: _.clone(this.includeOperatorControl.value),
      excludeOperator: _.clone(this.excludeOperatorControl.value)
    };
    this.mapConceptSetData();
  }

  cancel() {
    this.open = false;
    this.updateDataConfig();
    this.updateSelectionText();
  }

  saveContextualData() {
    this.open = false;
    this.resetData();
    if (this.contextualType === this.contextualTargetingType.targetsSets.key) {
      this.conceptSetControl.patchValue({
        id: this.selectedConceptSet[0].id,
        name: this.selectedConceptSet[0].name
      });
    } else {
      this.includeStackControl.patchValue(_.clone(this.contextualDataConfig.include));
      this.excludeStackControl.patchValue(_.clone(this.contextualDataConfig.exclude));
      this.includeOperatorControl.patchValue(this.contextualDataConfig.includeOperator);
      this.excludeOperatorControl.patchValue(this.contextualDataConfig.excludeOperator);
    }
    this.updateSelectionText();
  }

  updateSelectionText() {
    this.tooltipTextForInclude = [];
    this.tooltipTextForExclude = [];
    this.includeListCount = _.size(this.includeStackControl.value) || 0;
    this.excludeListCount = _.size(this.excludeStackControl.value) || 0;

    if (this.includeListCount === 1) {
      this.includeListCount = this.includeStackControl.value[0].name;
    }

    if (this.excludeListCount === 1) {
      this.excludeListCount = this.excludeStackControl.value[0].name;
    }
    this.tooltipTextForInclude = _.map(this.includeStackControl.value, (item) => item.name);
    this.tooltipTextForExclude = _.map(this.excludeStackControl.value, (item) => item.name);

    //Concept Set
    this.conceptSetLabel = this.conceptSetControl.value && this.conceptSetControl.value.name || '';
  }

  resetData() {
    this.includeStackControl.patchValue([]);
    this.excludeStackControl.patchValue([]);
    this.includeOperatorControl.patchValue(Operator.or);
    this.excludeOperatorControl.patchValue(Operator.or);
    this.conceptSetControl.patchValue({});
  }

  get includeStackControl(): FormControl {
    return this.contextualControl.get("includeStack") as FormControl;
  }

  get excludeStackControl(): FormControl {
    return this.contextualControl.get("excludeStack") as FormControl;
  }

  get includeOperatorControl(): FormControl {
    return this.contextualControl.get("includeOperator") as FormControl;
  }

  get excludeOperatorControl(): FormControl {
    return this.contextualControl.get("excludeOperator") as FormControl;
  }

  get conceptSetControl(): FormControl {
    return this.contextualControl.get("conceptSet") as FormControl;
  }

  get contextualControl() {
    return this.formArray.controls[this.group].get("contextual") as FormGroup;
  }

  get isDisabled(): boolean {
    return this.conceptSetControl.disabled;
  }

  get isContextualDisabled(): boolean {
    return this.contextualControl.disabled;
  }

}
